import { MultiCollapsible } from "@bonliva-crm/ui";
import {
  ProfessionFilterModalInnerProps,
  encodeValue,
  toDecodedLabelValue,
  getProfessionToValue,
  renderSelectType
} from "../../utils";
import { ComponentProps, useMemo, useState } from "react";
import { Option } from "../../utils";
import { useGlobalStore } from "@hooks";
import locale from "@bonliva-crm/locale";
import { SelectType } from "@bonliva-crm/shared";
import { ExperienceAndJobofferFilter } from "./common/experience-and-joboffer-filter";
import {
  baseOnChange,
  commonCollapsibleProps,
  isCollapsed,
  isGroupSelected,
  filterOption,
  isOptionStandAlone,
  onCollapse
} from "./utils";
import { isFilterSelected } from "../../../../utils/is-filter-selected";
import { uniqBy } from "lodash";

export const SSKFilter = (props: ProfessionFilterModalInnerProps) => {
  const store = useGlobalStore();
  const [collapsedGroups, setCollapsedGroups] = useState<string[]>([]);

  const professionKey = getProfessionToValue(props?.value?.professions?.[0]);

  const professionObject = useMemo(() => {
    return props?.value?.[professionKey];
  }, [props?.value]);

  if (
    !("areaOfExpertise" in professionObject) ||
    !("specializations" in professionObject)
  ) {
    return null;
  }

  const areaOfExpertise = store.cache.getAreaOfExpOnProfessions(
    props?.value?.professions
  );

  const valueAOE = professionObject.areaOfExpertise.value;
  const typeAOE = professionObject.areaOfExpertise.type;
  const valueSpec = professionObject.specializations.value;
  const typeSpec = professionObject.specializations.type;
  const professions = props.value.professions;

  const areas: Option[] = [];
  const specs: Option[] = [];

  const isAOEonly = true;

  areaOfExpertise.forEach((area) => {
    if (professions.includes(area.Profession)) {
      // if (!areas.some((a) => a.value === area.Profession)) {
      //   areas.push({
      //     label: area.Profession,
      //     value: area.Profession
      //   });
      // }

      areas.push({
        label: area.Name,
        value: encodeValue(area.Profession, area.Name)
      });

      // if (!specs.some((s) => s.value === area.Profession)) {
      //   specs.push({
      //     label: area.Profession,
      //     value: area.Profession
      //   });
      // }
      area.Specializations.forEach((s) => {
        specs.push({
          label: s,
          value: encodeValue(area.Profession, s)
        });
      });
    }
  });

  const onChangeAOE = baseOnChange(
    areas,
    (finalValues) => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          specializations: {
            value: valueSpec,
            type: typeSpec
          },
          areaOfExpertise: {
            value: finalValues.map((x) => x.value),
            type: typeAOE
          }
        },
        interested: finalValues.length > 0 ? props?.value?.interested : "null",
        experienced: finalValues.length > 0 ? props?.value?.experienced : "null"
      });
    },
    isAOEonly
  );

  const onChangeSpec = baseOnChange(
    specs,
    (finalValues) => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          areaOfExpertise: {
            value: valueAOE,
            type: typeAOE
          },
          specializations: {
            value: finalValues.map((x) => x.value),
            type: typeSpec
          }
        },
        interested: finalValues.length > 0 ? props?.value?.interested : "null",
        experienced: finalValues.length > 0 ? props?.value?.experienced : "null"
      });
    },
    isAOEonly
  );

  const commonProps: ComponentProps<typeof MultiCollapsible<Option>> = {
    ...commonCollapsibleProps,
    isCollapsed: isCollapsed(collapsedGroups),
    onCollapse: onCollapse(collapsedGroups, setCollapsedGroups)
  };

  const multiCollapsibleAOEProps: ComponentProps<typeof MultiCollapsible<Option>> = {
    ...commonProps,
    inputLabel: locale.AreaOfExpertise,
    placeholder: null,
    options: areas,
    value: toDecodedLabelValue(valueAOE),
    onChange: onChangeAOE,
    isOptionSelected: isGroupSelected(valueAOE, areas, true),
    isIndeterminate: isGroupSelected(valueAOE, areas, false),
    filterOption: filterOption(collapsedGroups, isAOEonly, valueAOE),
    isCollapsed: isCollapsed(collapsedGroups),
    isOptionStandAlone: isOptionStandAlone(areas),
    onCollapse: onCollapse(collapsedGroups, setCollapsedGroups),
    showBadge: isFilterSelected(professionObject.areaOfExpertise),
    isClearable: isFilterSelected(professionObject.areaOfExpertise),
    onClear: () => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          ...professionObject,
          areaOfExpertise: {
            type: SelectType.ANY,
            value: []
          }
        },
        experienced: null,
        interested: null
      });
    },
    menuChildren: {
      prependedChildren: renderSelectType(typeAOE, (t: SelectType) => {
        props.onChange({
          ...props?.value,
          [professionKey]: {
            ...professionObject,
            areaOfExpertise: {
              value: valueAOE,
              type: t
            }
          }
        });
      })
    }
  };

  const multiCollapsibleSpecProps: ComponentProps<typeof MultiCollapsible<Option>> = {
    ...commonProps,
    inputLabel: locale.Specialization,
    placeholder: null,
    options: uniqBy(specs, "value"),
    value: toDecodedLabelValue(valueSpec),
    onChange: onChangeSpec,
    isOptionSelected: isGroupSelected(valueSpec, specs, true),
    isIndeterminate: isGroupSelected(valueSpec, specs, false),
    filterOption: filterOption(collapsedGroups, isAOEonly, valueSpec),
    isCollapsed: isCollapsed(collapsedGroups),
    isOptionStandAlone: isOptionStandAlone(specs),
    onCollapse: onCollapse(collapsedGroups, setCollapsedGroups),
    showBadge: isFilterSelected(professionObject.specializations),
    isClearable: isFilterSelected(professionObject.specializations),
    onClear: () => {
      props.onChange({
        ...props?.value,
        [professionKey]: {
          ...professionObject,
          specializations: {
            type: SelectType.ANY,
            value: []
          }
        },
        experienced: null,
        interested: null
      });
    },
    menuChildren: {
      prependedChildren: renderSelectType(typeSpec, (t: SelectType) => {
        props.onChange({
          ...props?.value,
          [professionKey]: {
            ...professionObject,
            specializations: {
              value: valueSpec,
              type: t
            }
          }
        });
      })
    }
  };

  return (
    <>
      <MultiCollapsible<Option> {...multiCollapsibleAOEProps} />
      <MultiCollapsible<Option> {...multiCollapsibleSpecProps} />
      {(valueAOE.length > 0 || valueSpec.length > 0) && (
        <ExperienceAndJobofferFilter {...props} />
      )}
    </>
  );
};
